"use strict";

var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
var __read = this && this.__read || function (o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o),
    r,
    ar = [],
    e;
  try {
    while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  } catch (error) {
    e = {
      error: error
    };
  } finally {
    try {
      if (r && !r.done && (m = i["return"])) m.call(i);
    } finally {
      if (e) throw e.error;
    }
  }
  return ar;
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ProfileMenu = exports.ProfileMenuDefaultProps = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importStar(require("styled-components"));
var theme_1 = require("@shapeable/theme");
var menu_1 = require("../elements/menu");
var menu_link_1 = require("../elements/menu-link");
var graphql_1 = require("../../utils/graphql");
var client_1 = require("@apollo/client");
var current_user_can_1 = require("../../utils/current-user-can");
var use_active_person_1 = require("../../hooks/use-active-person");
var use_app_routes_1 = require("../../hooks/use-app-routes");
var use_icons_1 = require("../../hooks/use-icons");
var use_lang_1 = require("../../hooks/use-lang");
var use_profile_menu_state_1 = require("../../hooks/use-profile-menu-state");
var use_app_state_1 = require("../../hooks/use-app-state");
var badge_1 = require("../elements/badge");
var router_1 = require("@reach/router");
var use_sites_1 = require("../../hooks/use-sites");
var sprintf_js_1 = require("sprintf-js");
var use_modal_1 = require("../../hooks/use-modal");
var site_rebuild_dialog_1 = require("../entities/site-rebuild-dialog");
exports.ProfileMenuDefaultProps = {};
// -------- Child Component Props -------->
// -------- Styles -------->
var ContainerStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  "], ["\n  "])))
});
var MenuLinkStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    ", ";\n    padding-top: ", ";\n    &:last-child {\n      padding-top: ", ";\n      background: none;\n    }\n  "], ["\n    ", ";\n    padding-top: ", ";\n    &:last-child {\n      padding-top: ", ";\n      background: none;\n    }\n  "])), theme_1.theme.H_DOT_BG_END(), theme_1.theme.UNIT(4, 2), theme_1.theme.UNIT(4))
});
var HeaderStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n    background: ", ";\n    padding: ", ";\n    color: ", ";\n    display: flex;\n    justify-content: space-between;\n    font-weight: 500;\n    font-size: ", ";\n    \n  "], ["\n    background: ", ";\n    padding: ", ";\n    color: ", ";\n    display: flex;\n    justify-content: space-between;\n    font-weight: 500;\n    font-size: ", ";\n    \n  "])), theme_1.theme.COLOR('light'), theme_1.theme.UNIT(4), theme_1.theme.COLOR('textTag'), theme_1.theme.FONT_SIZE(15))
});
var BadgeStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
var DialogStyles = (0, theme_1.breakpoints)({
  base: (0, styled_components_1.css)(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n    \n  "], ["\n    \n  "])))
});
// -------- Components -------->
var My = {
  Container: (0, styled_components_1.default)(menu_1.Menu)(templateObject_6 || (templateObject_6 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles),
  Header: styled_components_1.default.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["", ""], ["", ""])), HeaderStyles),
  Badge: (0, styled_components_1.default)(badge_1.Badge)(templateObject_8 || (templateObject_8 = __makeTemplateObject(["", ""], ["", ""])), BadgeStyles),
  MenuLink: (0, styled_components_1.default)(menu_link_1.MenuLink)(templateObject_9 || (templateObject_9 = __makeTemplateObject(["", ""], ["", ""])), MenuLinkStyles),
  RebuildDialog: (0, styled_components_1.default)(site_rebuild_dialog_1.SiteRebuildDialog)(templateObject_10 || (templateObject_10 = __makeTemplateObject(["", ""], ["", ""])), DialogStyles)
};
var ProfileMenu = function (props) {
  var className = props.className;
  var _a = __read((0, client_1.useLazyQuery)(graphql_1.REFRESH_DATA_QUERY, {
      fetchPolicy: "no-cache"
    }), 2),
    refreshData = _a[0],
    _b = _a[1],
    isRefreshing = _b.loading,
    data = _b.data;
  var _c = __read((0, client_1.useMutation)(graphql_1.DEPLOY_MUTATION), 2),
    deploy = _c[0],
    _d = _c[1],
    deployLoading = _d.loading,
    deployData = _d.data;
  (0, react_1.useEffect)(function () {
    if (data && !isRefreshing) {
      if (typeof window !== "undefined") {
        window.location.reload();
      }
    }
  }, [isRefreshing]);
  var modal = (0, use_modal_1.useModal)();
  var personResult = (0, use_active_person_1.useActivePerson)();
  var person = personResult.person;
  var _e = (0, use_sites_1.useSites)(),
    sites = _e.sites,
    loading = _e.loading;
  var profileMenu = (0, use_profile_menu_state_1.useProfileMenuState)();
  var t = (0, use_lang_1.useLang)();
  var role = person && person.role && person.role.name;
  var _f = __read((0, use_app_state_1.useAppState)(), 2),
    appState = _f[0],
    setAppState = _f[1];
  var routes = (0, use_app_routes_1.useAppRoutes)();
  var Icons = (0, use_icons_1.useIcons)();
  var refreshOnClick = function () {
    return __awaiter(void 0, void 0, void 0, function () {
      return __generator(this, function (_a) {
        switch (_a.label) {
          case 0:
            setAppState(__assign(__assign({}, appState), {
              isRefreshing: true
            }));
            return [4 /*yield*/, refreshData()];
          case 1:
            _a.sent();
            return [2 /*return*/];
        }
      });
    });
  };
  var siteDeployOnClick = function (site) {
    return function () {
      modal.show(react_1.default.createElement(My.RebuildDialog, {
        entity: site,
        onCancel: function () {
          profileMenu.hide();
        },
        onConfirm: function () {
          profileMenu.hide();
        }
      }));
    };
  };
  var linkMenuOnClick = function (route) {
    return function () {
      profileMenu.hide();
      (0, router_1.navigate)(route);
    };
  };
  return react_1.default.createElement(My.Container, {
    className: className
  }, person && person.name && react_1.default.createElement(My.Header, null, person.name, role && react_1.default.createElement(My.Badge, null, role)), react_1.default.createElement(My.MenuLink, {
    icon: react_1.default.createElement(Icons.AppSections.Home, null),
    onClick: linkMenuOnClick(routes.home)
  }, t('Home')), react_1.default.createElement(My.MenuLink, {
    icon: react_1.default.createElement(Icons.Profile, null),
    onClick: linkMenuOnClick(routes.profile)
  }, t('My Profile')), react_1.default.createElement(My.MenuLink, {
    icon: react_1.default.createElement(Icons.AppSections.Connections, null),
    onClick: linkMenuOnClick(routes.connections)
  }, t('My Connections')), react_1.default.createElement(My.MenuLink, {
    icon: react_1.default.createElement(Icons.ChevronLeftCircle, null),
    to: routes.logout
  }, t('Logout')), (0, current_user_can_1.personCanAdmin)(personResult) && react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(My.MenuLink, {
    icon: react_1.default.createElement(Icons.GearsCircle, null),
    onClick: refreshOnClick
  }, t('Refresh Data')), sites.map(function (site) {
    return site.deploymentUrl && react_1.default.createElement(My.MenuLink, {
      icon: react_1.default.createElement(Icons.Entities.Site, null),
      onClick: siteDeployOnClick(site)
    }, (0, sprintf_js_1.sprintf)(t('Rebuild %s Website...'), site.name));
  })));
};
exports.ProfileMenu = ProfileMenu;
exports.ProfileMenu.defaultProps = exports.ProfileMenuDefaultProps;
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;